import {
  type CanvasElement,
  type CanvasElementId,
  type SlotId,
} from '@blaze-runtime/engine-domain';

import { isRootLike } from '../../canvas-elements/element-model/element-type-guards';

/**
 * Searches for elements present in a root-like element's slot that lack a parent node. If found, a parent node is added.
 * @param elements
 */
export function assignMissingParentNodes(elements: CanvasElement[]): void {
  const { rootElement, withoutParent } = findElementsWithoutParent(elements);

  if (!rootElement || withoutParent.length === 0) {
    return;
  }

  const childToSlotId = createChildToSlotIdMap(rootElement);

  for (const element of withoutParent) {
    const slotId = childToSlotId.get(element.id);
    if (slotId) {
      console.log(
        `${element.id} is missing a parent node. Assigning ${rootElement.id} as a parent.`,
      );
      element.parentNode = { id: rootElement.id, slot: slotId };
    }
  }
}

function createChildToSlotIdMap(rootElement: CanvasElement): Map<CanvasElementId, SlotId> {
  const childToSlotId = new Map<CanvasElementId, SlotId>();

  for (const slotId of rootElement.slots?.ids ?? []) {
    const slot = rootElement.slots?.[slotId];
    const children = slot?.children;
    if (!children || children.length === 0) {
      continue;
    }

    for (const elementId of children) {
      childToSlotId.set(elementId, slotId);
    }
  }

  return childToSlotId;
}

function findElementsWithoutParent(elements: CanvasElement[]): {
  rootElement: CanvasElement | undefined;
  withoutParent: CanvasElement[];
} {
  let rootElement: CanvasElement | undefined;
  const withoutParent: CanvasElement[] = [];

  for (const element of elements) {
    if (!rootElement && isRootLike(element)) {
      rootElement = element;
      continue;
    }

    if (!element.parentNode) {
      withoutParent.push(element);
    }
  }

  return { rootElement, withoutParent };
}
